// extracted by mini-css-extract-plugin
export default {"btn_add_clear":"ModalAddWallet_btn_add_clear__uNjee","errorText":"ModalAddWallet_errorText__3+EG2"};